// extracted by mini-css-extract-plugin
module.exports = {"container":"CookiesPage_container__YVNe3","titles":"CookiesPage_titles__wL23B","titleSubtitle":"CookiesPage_titleSubtitle__SDrzz","richElement":"CookiesPage_richElement__v7dY_"};